module.exports = "/assets/data/ca773e4e0c7762069fda1695493d78d2-G71.data.json";